import LinkToStripeButton from "../../../common/LinkToStripeButton";
import { LinkToStripe } from "../tabs/types";

const LinkSolutionToStripeButton = ({
  linkToStripe,
}: {
  linkToStripe: LinkToStripe;
}) => {
  return (
    <LinkToStripeButton
      handleClick={() => linkToStripe.link()}
      loading={linkToStripe.loading}
    />
  );
};

export default LinkSolutionToStripeButton;
